{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}
unit Character;

interface

uses
  SysUtils;

type
  EChar = class(Exception);

  TCharHelper = record helper for Char
  strict private
    class procedure CheckZeroStringRange(const AValue: string; AIndex: Integer); static;
    class procedure RaiseCheckStringRangeException(AIndex, ALowIndex, AMaxIndex: Integer); static;
  public const
    Length = 1;
    Size = 2;
  public
    function IsDigit: Boolean;
    function IsInArray(const AChars: array of Char): Boolean; overload;
    class function IsInArray(const AValue: string; AIndex: Integer; const AChars: array of Char): Boolean; overload; static;
    function IsLetter: Boolean;
    function IsLetterOrDigit: Boolean;
    function ToLower: Char; overload;
    class function ToLower(const AValue: Char): Char; overload; assembler; static;
    function ToOrd: Integer;
    function ToUpper: Char; overload;
    class function ToUpper(const AValue: Char): Char; overload; assembler; static;
  end;

implementation

resourcestring
  SArgumentOutOfRange = 'The string index is out of range (%d). Must be >= %d and <= %d';

{ TCharHelper }

class procedure TCharHelper.CheckZeroStringRange(const AValue: string; AIndex: Integer);
var
  lMaxIndex: Integer;
begin
  lMaxIndex := High(AValue);
  if (AIndex > lMaxIndex) or (AIndex < 0) then
    RaiseCheckStringRangeException(AIndex, 0, lMaxIndex);
end;

function TCharHelper.IsDigit: Boolean;
const
  cNumChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
begin
  Result := Self in cNumChars;
end;

function TCharHelper.IsInArray(const AChars: array of Char): Boolean;
var
  lChar: Char;
begin
  for lChar in AChars do
  begin
    if lChar = Self then
      Exit(True);
  end;
  Result := False;
end;

class function TCharHelper.IsInArray(const AValue: string; AIndex: Integer; const AChars: array of Char): Boolean;
var
  lChar: Char;
begin
  CheckZeroStringRange(AValue, AIndex);
  lChar := AValue[AIndex];
  Result := lChar.IsInArray(AChars);
end;

function TCharHelper.ToLower: Char;
begin
  Result := ToLower(Self);
end;

function TCharHelper.IsLetter: Boolean;
begin
  Result := ToLower <> ToUpper;
end;

function TCharHelper.IsLetterOrDigit: Boolean;
begin
  Result := IsLetter or IsDigit;
end;

class procedure TCharHelper.RaiseCheckStringRangeException(AIndex, ALowIndex, AMaxIndex: Integer);
begin
  raise EChar.CreateFmt(SArgumentOutOfRange, [AIndex, ALowIndex, AMaxIndex]);
end;

class function TCharHelper.ToLower(const AValue: Char): Char;
asm
  return AValue.toLowerCase();
end;

function TCharHelper.ToOrd: Integer;
begin
  Result := Ord(Self);
end;

function TCharHelper.ToUpper: Char;
begin
  Result := ToUpper(Self);
end;

class function TCharHelper.ToUpper(const AValue: Char): Char;
asm
  return AValue.toUpperCase();
end;

end.
